<template>
    <div id="naasHeader" class="bg-white shadow overflow-hidden sm:rounded-lg mb-5">
        <div class="grid grid-cols-6 px-4 py-5 sm:px-6 place-items-center">
            <div class="col-span-6 justify-self-start">
                <div class="align-middle">
                    <h3 class="text-lg leading-6 font-medium text-gray-900">No Access Areas ({{ noAccessAreas.length }})</h3>
                </div>
            </div>
        </div>
    </div>

    <div id="naasContainer">
        <template v-for="(noAccessArea, $i) of noAccessAreas">
            <div class="bg-white shadow overflow-hidden sm:rounded-lg mb-1 sm:mb-4">
                <div class="grid grid-cols-2 gap-5">

                    <div class="col-span-2 border-t border-gray-200">
                        <dl>
                            <div class="border-b px-4 py-3 grid grid-cols-1">
                                <image-container @image-click="handleImageClick" :item="noAccessArea" />
                            </div>

                            <div class="border-b px-4 py-3 grid grid-cols-2">
                                <div class="col-span-2 font-bold">
                                    <dt class="text-sm font-medium text-gray-500">
                                        Location :
                                    </dt>
                                    <dd class="text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        {{ noAccessArea.room }}, {{ noAccessArea.location }}
                                    </dd>
                                </div>
                                <div class="col-span-2">
                                    <dt class="text-sm font-medium text-gray-500">
                                        Building :
                                    </dt>
                                    <dd class="text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        {{ noAccessArea.building }}
                                    </dd>
                                </div>
                                <div class="col-span-2">
                                    <dt class="text-sm font-medium text-gray-500">
                                        Floor :
                                    </dt>
                                    <dd class="text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        {{ noAccessArea.floor }}
                                    </dd>
                                </div>
                            </div>

                            <div :class="['border-b px-4 py-3 grid grid-cols-2 sm:block', { 'hidden': !isExpanded($i) } ]">
                                <div class="col-span-2">
                                    <dt class="text-sm font-medium text-gray-500">
                                        Reason :
                                    </dt>
                                    <dd class="text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        {{ noAccessArea.reason }}
                                    </dd>
                                </div>
                                <div class="col-span-2">
                                    <dt class="text-sm font-medium text-gray-500">
                                        Recommendation :
                                    </dt>
                                    <dd class="text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        {{ noAccessArea.recommendation }}
                                    </dd>
                                </div>
                                <div class="col-span-2">
                                    <dt class="text-sm font-medium text-gray-500">
                                        Action / Review Date :
                                    </dt>
                                    <dd class="text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                        {{ noAccessArea.action_date }}
                                    </dd>
                                </div>
                            </div>

                        </dl>
                    </div>
                </div>
            </div>
            <button @click="toggleExpand($i)" class="block sm:hidden mb-4 w-full inline-flex justify-center py-2 px-4 border border-uknar-primary-dark shadow-sm text-sm font-medium rounded-md text-white bg-uknar-primary hover:bg-uknar-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary">
                <template v-if="!isExpanded($i)">View Additional Information</template>
                <template v-else>View Less Information</template>
            </button>
        </template>
    </div>
    <div v-if="!noAccessAreas.length" class="overflow-hidden shadow rounded-lg mb-4">
        <div class="bg-gray-50 px-4 py-5 sm:p-6 text-center">
            <p>All areas were accessed.</p>
        </div>
    </div>
</template>

<script>
import ImageContainer from "./ImageContainer";

export default {
    name: 'NoAccessAreas',
    props: ['noAccessAreas'],

    components: { ImageContainer },

    data() {
        return {
            expanded: []
        }
    },

    methods: {
        isExpanded(i) {
            return this.expanded.indexOf(i) > -1;
        },

        toggleExpand(i) {
            if(this.isExpanded(i)) {
                this.expanded.splice(this.expanded.indexOf(i), 1);
            } else {
                this.expanded.push(i);
            }
        },

        handleImageClick(imageUrl) {
            this.$emit('image-click', imageUrl);
        }
    }
}
</script>

<style scoped>
dt, dd {
    display: inline-block;
    margin-right: 6px;
}

#naasHeader {
    margin-top: 58px;
    left: 0;
    z-index: 1;
}
</style>

